const BODY_SELECTOR = 'body'
  const getTimeRemaining = (endtime) => {
    const total = Date.parse(endtime) - Date.now()
    if (total <= 0) {
      return {
        total: 0,
        minutes: 0,
        seconds: 0,
      }
    }
    const seconds = Math.floor((total / 1000) % 60)
    const minutes = Math.floor((total / 1000 / 60) % 60)

    return {
      total,
      minutes,
      seconds,
    }
  }

  const initializeClock = (root, selector, endtime) => {
    const clock = root.querySelector(selector)
    const minutesSpan = clock.querySelector('.minutes')
    const secondsSpan = clock.querySelector('.seconds')

    function updateClock() {
      const t = getTimeRemaining(endtime)

      minutesSpan.innerHTML = ('0' + t.minutes).slice(-2)
      secondsSpan.innerHTML = ('0' + t.seconds).slice(-2)

      if (t.total <= 0) {
        clearInterval(timeinterval)
      }
    }

    updateClock()
    const timeinterval = setInterval(updateClock, 1000)
  }

  const createFooter = (endtime, discountCode) => {
    const root = document.createElement('div')
    root.setAttribute('id', 'countdown')
    root.innerHTML = `
    <div class="footer">
      <span class="close-button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="#fff" stroke="#fff"/><path d="M0 0h24v24H0z" fill="none"/></svg></span>
      <div>
        <span class="normal_text">初回限定 対象商品30%OFF</span>
      </div>
      <div class="discount_code">
        <span class="normal_text">クーポンコード: <span style="font-weight:bold;">${discountCode}</span></span>
      </div>
      <div>
        <span class="minutes"></span>分<span class="seconds"></span>秒後にクーポンコードが失効します。
      </div>
    </div>
    `
    initializeClock(root, '.footer', new Date(endtime))

    const closeButton = root.querySelector('.close-button')
    if (!closeButton) return

    function toggleModalAndShowDiscountBadge() {
      root.classList.add('hide-footer')
      const $discountBadge = document.querySelector('.discount_badge')
      $discountBadge.classList.remove('hide-discount-badge')
    }
    closeButton.addEventListener('click', toggleModalAndShowDiscountBadge)
    return root
  }

  const createDiscountBadge = () => {
    const root = document.createElement('div')
    root.setAttribute('class', 'discount_badge')
    root.innerHTML = `
    <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><desc></desc><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="9" y1="15" x2="15" y2="9"></line><circle cx="9.5" cy="9.5" r=".5" fill="currentColor"></circle><circle cx="14.5" cy="14.5" r=".5" fill="currentColor"></circle><path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"></path></svg>
    `
    const handleClick = () => {
      root.classList.add('hide-discount-badge')
      const $countdown = document.querySelector('#countdown')
      $countdown.classList.remove('hide-footer')
    }
    root.addEventListener('click', handleClick)
    return root
  }

  const isExpired = (expDate) => Date.now() > new Date(expDate).getTime()
  const executeAfterSell = () => {
    const discount = JSON.parse(localStorage.getItem('after-sell-coupon'))
    if(!discount) return
    const {code, expDate} = discount
    if(isExpired(expDate)) return
    const footer = createFooter(expDate, code)
    footer.classList.add('hide-footer')
    const discountBadge = createDiscountBadge()

    const content = document.querySelector(BODY_SELECTOR)
    content && content.appendChild(footer) && content.appendChild(discountBadge)
  }
  executeAfterSell()
